import { createContext, useContext } from 'react';
var BreadcrumbContext =
/*#__PURE__*/
createContext({});

var useBreadcrumbContext = function useBreadcrumbContext() {
  return useContext(BreadcrumbContext);
};

export { BreadcrumbContext, useBreadcrumbContext };